import { ASSETS_URL } from "@commons-monorepo/constants";
import {
  PAYMENT_GATEWAY,
  PAYMENT_OPTION,
} from "../types/payment-methods.types";

export const PAYMENT_OPTIONS = {
  [PAYMENT_OPTION.VISA]: {
    id: "visa",
    logo: `${ASSETS_URL}/prod/payments/methods/visa.png`,
  },
  [PAYMENT_OPTION.MASTERCARD]: {
    id: "master",
    logo: `${ASSETS_URL}/prod/payments/methods/master.png`,
  },
  [PAYMENT_OPTION.AMEX]: {
    id: "american",
    logo: `${ASSETS_URL}/prod/payments/methods/america.png`,
  },
  [PAYMENT_OPTION.EFECTY]: {
    id: "efecty",
    logo: `${ASSETS_URL}/prod/payments/methods/efecty.png`,
  },
  [PAYMENT_OPTION.NEQUI]: {
    id: "efecty",
    logo: `${ASSETS_URL}/prod/mobile/payments/custom-payments/nequi2.png`,
  },
  [PAYMENT_OPTION.DAVIPLATA]: {
    id: "dvv",
    logo: `${ASSETS_URL}/prod/mobile/payments/custom-payments/dvv.png`,
  },
  [PAYMENT_OPTION.DAVIVIENDA]: {
    id: "davivienda",
    logo: `${ASSETS_URL}/prod/payments/methods/davivienda.webp`,
  },
  [PAYMENT_OPTION.PSE]: {
    id: "davivienda",
    logo: `${ASSETS_URL}/prod/payments/methods/pse.webp`,
  },
  [PAYMENT_OPTION.CASH]: {
    id: "money",
    logo: `${ASSETS_URL}/prod/mobile/payments/custom-payments/money2.png`,
  },
  [PAYMENT_OPTION.WALLET]: {
    id: "wallet",
    logo: `${ASSETS_URL}/prod/mobile/payments/custom-payments/wallet2.png`,
  },
  [PAYMENT_OPTION.TRANSFER]: {
    id: "cc2",
    logo: `${ASSETS_URL}/prod/mobile/payments/custom-payments/cc2.png`,
  },
};

export const PAYMENT_GATEWAYS = {
  [PAYMENT_GATEWAY.MERCADOPAGO]: [
    PAYMENT_OPTION.VISA,
    PAYMENT_OPTION.MASTERCARD,
    PAYMENT_OPTION.AMEX,
  ],
  [PAYMENT_GATEWAY.EPAYCO]: [
    PAYMENT_OPTION.VISA,
    PAYMENT_OPTION.MASTERCARD,
    PAYMENT_OPTION.AMEX,
    PAYMENT_OPTION.DAVIVIENDA,
    PAYMENT_OPTION.DAVIPLATA,
    PAYMENT_OPTION.PSE,
  ],
  [PAYMENT_GATEWAY.WOMPI]: [
    PAYMENT_OPTION.VISA,
    PAYMENT_OPTION.MASTERCARD,
    PAYMENT_OPTION.AMEX,
    PAYMENT_OPTION.NEQUI,
    PAYMENT_OPTION.PSE,
  ],
  [PAYMENT_GATEWAY.PAYPAL]: [
    PAYMENT_OPTION.VISA,
    PAYMENT_OPTION.MASTERCARD,
    PAYMENT_OPTION.AMEX,
  ],
  [PAYMENT_GATEWAY.BOLD]: [
    PAYMENT_OPTION.VISA,
    PAYMENT_OPTION.MASTERCARD,
    PAYMENT_OPTION.AMEX,
    PAYMENT_OPTION.PSE,
  ],
  [PAYMENT_GATEWAY.ADDI]: [
    PAYMENT_OPTION.VISA,
    PAYMENT_OPTION.MASTERCARD,
    PAYMENT_OPTION.AMEX,
    PAYMENT_OPTION.PSE,
  ],
};
